import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  fieldGroup: {
    marginTop: 22,
  },
  fieldTitle: {
    display: "inline-block",
    marginLeft: 9,
    marginBottom: 10,
  },
  addressCaption: {
    display: "inline-block",
    marginTop: 4,
    marginBottom: 11,
    marginLeft: theme.spacing(2),
    letterSpacing: "0.004em",
    color: "rgba(20, 30, 48, 0.5)",
  },
  addAltPhone: {
    color: "#2B59C3",
    display: "inline-block",
    marginBottom: 2,
  },
  addAltphoneText: {
    display: "inline-block",
  },
  btnGroup: {
    marginTop: theme.spacing(3),
  },
  submitBtn: {
    padding: theme.spacing(2),
    fontSize: "14px !important",
    color: "#ffff",
    backgroundColor: "#2B59C3",
    opacity: 1,
    "&:disabled": {
      opacity: 0.5,
      backgroundColor: "#2B59C3 !important",
    },
  },
  cancelBtn: {
    marginLeft: theme.spacing(2),
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    fontSize: "14px !important",
    color: theme.palette.primary.main,
  },
  fieldWrapper: {
    display: "flex",
  },
  cityField: {
    marginLeft: theme.spacing(1),
  },
  titleWrapper: {
    display: "flex",
  },
  checkbox: {
    "& span": {
      "& svg": {
        fill: "darkgrey",
      },
    },
  },
  formControllLabel: {
    alignItems: "center",
  },
  infoWrapper: {
    display: "flex",
    alignItems: "center",
  },
  infoText: {
    marginLeft: theme.spacing(1),
  },
  summaryTitle: {
    marginTop: theme.spacing(3),
    color: theme.palette.text.secondary,
    textAlign: "center",
  },
  colorHouseIcon: {
    width: 80,
    height: 80,
    marginTop: 20,
    marginBottom: 16,
  },
}));
